// extracted by mini-css-extract-plugin
module.exports = {"root":"ManageBrandRestrictedCategories_root__3HCBG","header":"ManageBrandRestrictedCategories_header__pLme6"};